module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Info', {
    attrs: {
      "title": "Contact Information"
    }
  }, [_c('article', [_c('p', [_vm._v("\n      Please contact us via\n      "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/Quick-Tourney-406848122730934/"
    }
  }, [_vm._v("our facebook page.")])]), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": "https://www.facebook.com/Quick-Tourney-406848122730934/",
      "data-layout": "standard",
      "data-action": "like",
      "data-size": "large",
      "data-show-faces": "true",
      "data-share": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": "https://www.facebook.com/Quick-Tourney-406848122730934/",
      "data-layout": "standard",
      "data-action": "recommend",
      "data-size": "large",
      "data-show-faces": "true",
      "data-share": "true"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eca6bd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactInfo.vue
// module id = 457
// module chunks = 1